import {ACTION_CODE} from './_actionCode';
import {ExpenseTypeService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_EXPENSE_TYPES';

export async function getAllExpenseTypes(
    userData: UserState["userProfileData"],
    params = '',
    page = 1
) {
    try {
        LoggerService.logInfo('Action - getAllExpenseTypes - Start');

        const getAllExpenseTypesResult = await ExpenseTypeService.getAllExpenseTypes(userData, params, page);

        LoggerService.logInfo('Action - getAllExpenseTypes - End - Success');

        return ResultModel.newSuccessResult(getAllExpenseTypesResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllExpenseTypes - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récuperation de la liste des types de frais .',
            error: error
        });

        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
